// 阿里oss静态地址前缀
export const AliOss = "https://shbd.oss-cn-beijing.aliyuncs.com/%E7%A2%B3%E4%B8%AD%E5%92%8C"

// iframe
export const IframeUrl = 'https://iframe.stiacn.com'

// 主题色
export const ThemeColor = '#51AA52'

export const barFontSize = '0.22rem' // 标题字体大小

export const barHeight = '0.7rem'

// 分割线
export const CutLine = '1px solid rgba(0,0,0,0.1)'

// 域名
export const ProxyUrl = 'https://api.stiacn.com'
// export const ProxyUrl = 'http://124.222.138.45:8068'